// extracted by mini-css-extract-plugin
export default {"bubbleOption":"bubbleOption__peTUV9VG","selected":"selected__jY1VgrfT","optionFullWidth":"optionFullWidth__ceI2FfTS"};